import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../context/ProtectedRoute';
import LumenDashboard from '../projects/ESID-25-011/pages/dashboard';
import LumenReports from '../projects/ESID-25-011/pages/report';
function LummenRoutes({setLoading, triggerAlert}) {
  return (
    <Routes>
      <Route path="dashboard" element={
        <ProtectedRoute project="esid-25-011">
          <LumenDashboard setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="reports" element={
        <ProtectedRoute project="esid-25-011">
          <LumenReports setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
     
    </Routes>
  );
}

export default LummenRoutes;